
































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import "bootstrap-vue";
import store from '@/services/store';
import PlanScheduleTab from '@/modules/budget/execution/loan/tabs/PlanScheduleTab.vue'
import FactScheduleTab from '@/modules/budget/execution/loan/tabs/FactScheduleTab.vue'
import Fact2ScheduleTab from '@/modules/budget/execution/loan/tabs/Fact2ScheduleTab.vue'
import ForecastScheduleTab from '@/modules/budget/execution/loan/tabs/ForecastScheduleTab.vue'
import CFileLoad from '@/modules/budget/execution/loan/components/file-load.vue'
// import { validationMixin } from 'vuelidate';
import VueElementLoading from 'vue-element-loading';
// import { required, helpers, minLength, maxLength, numeric } from 'vuelidate/lib/validators';
import Multiselect from "vue-multiselect";
import { cloneDeep, debounce } from 'lodash';
import Datepicker from "vue2-datepicker"
// import axios from 'axios'
import { AgreementForm } from './types/AgreementForm';
import { Option } from './types/Option';
import { Agreement } from './types/Agreement';
import moment from 'moment';
import axios from 'axios';
import { parseSpacedDecimal } from './utils';
import { AgreementFile } from './types/AgreementFile';
import { AgreementCard, AgreementDataRequest, FactData, PlanCardRow, PlanData } from './types/AgreementDataRequest';
import { ScheduleRow } from './types/ScheduleRow';

interface FormEntry {
    key: keyof AgreementForm
    type: 'text' | 'date' | 'radio' | 'number' | 'textarea' | 'select' | 'asyncSelect'
    label: string
    validation?: {
        required?: boolean
        numeric?: boolean
        whole?: boolean
        maxFloat?: number
        digitReadability?: boolean
    }
    valueProperty?: string
    optionsUrl?: string,
    params?: Record<string, any>
    nameFields?: string[]
}

type FormMode = 'view' | 'edit' | 'add' | 'add-additional' | 'add-lower-level'

type ContractorType = 'GU' | 'OTHER'

type FormOptions = {
    budgetLevels: Option<number>[]
    creditors: Option<string>[]
    currencies: Option<string>[]
    loanTypes: Option<string>[]
    loanDirections: Option<string>[]
    loanPurposes: Option<string>[]
    administrators: Option<string>[]
    contractorTypes: Option<ContractorType>[]
    contractors: Option<string>[]
    prgs: Option<string>[]
    pprs: Option<string>[]
    projects: Option<string>[]
    govPrograms: Option<string>[]
    statuses: Option<number>[]
}

const budgetLoanModuleCode = '005.007'
const guContractorTypeOption = { text: 'ГУ', value: 'gu' }
const otherContractorTypeOption = { text: 'Иные (по БИН-у)', value: 'other' }

const budgetLevelOptions: Option<number>[] = [
    { value: 1, label: 'Республиканский бюджет' },
    { value: 2, label: 'Областной бюджет' },
    { value: 3, label: 'Районый бюджет' },
    { value: 4, label: 'Местное самоуправление' },
]

const loanTypeOptions: Option<string>[] = [
    { value: '1', label: 'Кредит' },
    { value: '2', label: 'Облигация' },
    { value: '3', label: 'Грант' },
]

const loanDirectionOptions: Option<string>[] = [
    { value: '1', label: 'Кредиты, предоставленные из республиканского бюджета' },
    { value: '2', label: 'Кредиты, выданные нижестоящим организациям за счет средств областного бюджета' },
    { value: '3', label: 'Внутреннее государственное заимствование' },
]

const statusOptions: Option<number>[] = [
    { value: 1, label: 'Действующий' },
    { value: 2, label: 'Погашен/Закрыт' },
    { value: 3, label: 'Возврат/Закрыт' },
]

const currencyOptions: Option<string>[] = [
    { value: '398', label: 'теңге' },
    { value: '840', label: 'Доллар США' },
]

const contractorTypeOptions: Option<ContractorType>[] = [
    { value: 'GU', label: 'ГУ' },
    { value: 'OTHER', label: 'Иные (по БИН-у)' }
]

const initialForm: AgreementForm = {
    id: null,
    budgetLevel: null,
    agreementNumber: '',
    signDate: null,
    returnDate: null,
    mainAgreementId: null,
    mainAgreementNumber: null,
    loanType: cloneDeep(loanTypeOptions.find(it => it.value === '1')!),
    loanDirection: null,
    loanPurpose: null,
    project: null,
    govProgram: null,
    creditor: null,
    administrator: null,
    contractorType: 'GU',
    contractor: null,
    prg: null,
    ppr: null,
    amount: '0',
    currency: cloneDeep(currencyOptions.find(it => it.value === '398')!),
    currencyRate: null,
    agreementYears: null,
    benefitMonths: '0',
    disbursementStartDate: null,
    disbursementEndDate: null,
    directResult: null,
    finalResult: null,
    rate: null,
    penalty: null,
    status: cloneDeep(statusOptions.find(it => it.value === 1)!),
    type: 0,
    isActual: true,
    noteRu: null,
    noteKz: null,
    files: [],

    index: 0,
    label: '',
    leftAmount: null,
    regionCode: null,
    frequency: null,
    frequencyRate: null,
    frequencyIncome: null,
    initialInterestRepaymentDate: null,
    followingInterestRepaymentMonth: null,
    followingInterestRepaymentDay: null,
    flagActual: 1,
    flagError: null,
    userName: null,
    updateDate: null
}

const emptyOptions: FormOptions = {
    budgetLevels: [],
    creditors: [],
    currencies: [],
    contractorTypes: [],
    administrators: [],
    loanDirections: [],
    loanPurposes: [],
    loanTypes: [],
    contractors: [],
    prgs: [],
    pprs: [],
    projects: [],
    govPrograms: [],
    statuses: [],
}

const editableFields: (keyof AgreementForm)[] = ['loanType', 'agreementNumber', 'signDate', 'noteRu', 'loanDirection', 'loanPurpose', 'project', 'govProgram', 'creditor', 'administrator', 'contractorType', 'contractor', 'amount', 'currency', 'currencyRate', 'rate', 'agreementYears', 'returnDate', 'benefitMonths', 'disbursementStartDate', 'disbursementEndDate', 'directResult', 'finalResult', 'penalty',
// 'frequency', 'frequencyRate', 'frequencyIncome', 'file',
'prg', 'ppr',  'status']
const notEditableAdditionalAgreementFields: (keyof AgreementForm)[] = ['loanType', 'mainAgreementNumber', 'budgetLevel', 'loanDirection', 'project', 'currency', 'loanPurpose', 'govProgram']
const notEditableLowerLevelAgreementFields: (keyof AgreementForm)[] = ['loanType', 'type', 'mainAgreementNumber', 'loanDirection', 'project', 'currency', 'loanPurpose', 'govProgram']

@Component({
    name: 'agreement-registration-form',
    components: {
        'loading': VueElementLoading,
        multiselect: Multiselect,
        'plan-schedule-tab': PlanScheduleTab,
        'fact-schedule-tab': FactScheduleTab,
        'fact2-schedule-tab': Fact2ScheduleTab,
        'forecast-schedule-tab': ForecastScheduleTab,
        'c-file-load': CFileLoad,
        'date-picker': Datepicker
    }
})
export default class AgreementFormPage extends Vue {
    // #region Data
    private availableForUser = true
    private serverKatoRegion: string | null = null
    private userAccessLevel = null
    private userRegions: string[] = []
    private userBudgetLevels: string[] = []
    private currentAgreementId: number | null = null
    public progress = 0
    public loading = false
    public showModal = false
    public inputTextModalVisibility = false
    public selectedTextField: keyof AgreementForm = 'directResult'
    public tempModalText = ''
    public modalEditingFieldName = ''
    public currentMode: FormMode = 'view'
    public form: AgreementForm = initialForm
    public tempForm: AgreementForm | null = null
    public tempOptions: FormOptions | null = null
    public mainAgreementForm: AgreementForm | null = null
    public actualAgreementForm: AgreementForm | null = null
    public allAgreementForms: AgreementForm[] = []
    public allAgreements: Agreement[] = []

    private agreementOptions: Record<number, FormOptions> = {}

    public options: FormOptions = cloneDeep(emptyOptions)
    public handleFormattedInput = {}
    // contractorType: 'gu'
    private tempContractor: Option<string> | null = null
        // frequencyOptions: [],
    private idsOfFilesToDelete: number[] = []
    private forecastSchedule: any[] = [] // TODO: set type

    public forecastTabKey: number = 0
    public loadings: Record<string, boolean> = {}
    private tableQuery: string | null = null

    public readonly actualityOptions: Option<boolean>[] = [
        { value: true, label: 'Актуальный' },
        { value: false, label: 'Неактуальный' }
    ]

    planData: any = null
    factData: any = null
    // #endregion

    // #region Computed
    get userId(): string | null {
        return store.state.user.sub ?? null
    }

    get isTestEnviroment(): boolean {
        return this.$store.state._instanceCode === ''
    }

    get isWriteAccess() {
        return (this.userAccessLevel ?? -1) >= 2
    }

    get isAdminAccess() {
        return (this.userAccessLevel ?? -1) >= 3
    }

    get isRepublicanBudget() {
        return this.form?.budgetLevel?.value === 1
    }

    get isActive() {
        return this.form?.status?.value === 1
    }

    get isActual() {
        return this.form.isActual
    }

    get isAdditionalAddable() {
        return this.isActive && this.isActual
    }

    get isLowerLevelAddable() {
        return this.isActive && this.isActual && this.isRepublicanBudget
    }
    // #endregion

    // #region Watches
    @Watch('form.currency', { deep: true })
    onCurrencyChange(newValue: any, oldValue: any) {
        if (newValue?.code === '398') {
            this.form.currencyRate = null
        }
    }
    // #endregion

    // #region Lifecycle
    private async created() {
        if (!this.checkUserModuleAccessAndSetAccessLevel()) {
            this.availableForUser = false
            this.makeToast('Отсутствует доступ к режиму', 'Сообщение', 'danger')
            return
        }

        this.loading = true
        this.setServerRegion()
        await this.setUserRegions()
        await this.setUserBudgetLevels()

        if (this.$route.params.tableQuery) {
            this.tableQuery = this.$route.params.tableQuery
        }

        const mode: FormMode = this.$route.params.mode as FormMode
        const id = this.$route.params.id ? parseInt(this.$route.params.id) : null
        await this.loadAgreementByIdAndSetMode(id, mode)
    }
    // #endregion

    // #region Methods

    async generateAgreementCardReport() {
        if (!this.planData || !this.factData) {
            this.makeToast('Данные для выгрузки все еще загружаются. Повторите через несколько секунд.', 'Сообщение', 'info')
            return
        }

        const planCardRows: PlanCardRow[] = this.planData.rows.map((it: any) => {
            const dateStr: string = moment(it.datePayment).format('YYYY-MM-DD')
            const startDateStr: string | null = it.dateBeg ? moment(it.dateBeg).format('YYYY-MM-DD') : null
            const endDateStr: string | null = it.dateEnd ? moment(it.dateEnd).format('YYYY-MM-DD') : null

            const mapped: PlanCardRow = {
                leftPrincipal: it.leftPrincipal ?? 0,
                date: dateStr,
                inflowSum: it.sumPayment ?? 0,
                principalSum: it.sumPaymentPrincipal ?? 0,
                startDate: startDateStr,
                endDate: endDateStr,
                daysCount: it.dayCount,
                baseSum: it.sumBase,
                interestSum: it.sumPaymentInterest ?? 0,
            }

            return mapped
        })

        const planData: PlanData = {
            inflowFrequency: this.planData.inflowFrequency ?? '',
            principalFrequency: this.planData.principalFrequency ?? '',
            interestFrequency: this.planData.interestFrequency ?? '',
            initialInflowDate: this.planData.initialInflowDate ?? '',
            initialPrincipalDate: this.planData.initialPrincipalDate ?? '',
            initialInterestDate: this.planData.initialInterestDate ?? '',
            followingInterestDay: this.planData.followingInterestDay ?? null,
            followingInterestMonth: this.planData.followingInterestMonth ?? null,
            rows: planCardRows
        }

        this.factData.rows.forEach((it: any) => it.earlyRepaymentFlag = it.isEarlyRepayment)

        const factRows: ScheduleRow[] = this.factData.rows
        const factData: FactData = {
            mainAgreementNumber: this.factData.mainAgreementNumber,
            actualAgreementNumber: this.factData.actualAgreementNumber,
            rows: factRows,
        }

        this.loading = true

        try {
            const agreementCard: AgreementCard = this.formToCard(this.form)
            const request: AgreementDataRequest = {
                agreementCard: agreementCard,
                planData: planData,
                factData: factData
            }

            const response = await fetch(`/api/budget-loan-reports/agreement-card`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(request)
            })
            if (!response.ok) {
                let message = 'Не удалось сформировать отчет'
                const errorResponse = await response.json()
                if (errorResponse?.key) {
                    message = errorResponse?.key
                }
                this.makeToast(message, 'Ошибка', 'danger')
                throw new Error('')
            }
            const blob = await response.blob()
            if (blob.size === 0) {
                this.makeToast('Отсутствуют данные', 'Сообщение', 'info')
                return
            }
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            const filename = `Договор ${agreementCard.agreementNumber} от ${agreementCard.signDate}`
            const extension = '.xlsx'
            link.href = url
            link.setAttribute('download', filename + extension)
            document.body.appendChild(link)
            link.click()
            // Cleanup
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        } catch (error) {
        } finally {
            this.loading = false
        }
    }

    formToCard(form: AgreementForm): AgreementCard {
        const signDateStr: string = form.signDate ? moment(form.signDate).format('YYYY-DD-MM') : ''
        const returnDateStr: string = form.returnDate ? moment(form.returnDate).format('YYYY-DD-MM') : ''
        const disbursementStartDateStr: string = form.disbursementStartDate ? moment(form.disbursementStartDate).format('YYYY-DD-MM') : ''
        const disbursementEndDateStr: string = form.disbursementEndDate ? moment(form.disbursementEndDate).format('YYYY-DD-MM') : ''

        const card: AgreementCard = {
            budgetLevel: form.budgetLevel?.label ?? '',
            agreementNumber: form.agreementNumber,
            signDate: signDateStr,
            mainAgreementNumber: form.mainAgreementNumber ?? '',
            creditor: form.creditor?.label ?? '',
            administrator: form.administrator?.label ?? '',
            contractorType: form.contractorType,
            contractor: form.contractor?.label ?? '',
            prg: form.prg?.label ?? '',
            ppr: form.ppr?.label ?? '',
            amount: form.amount,
            currency: form.currency?.label ?? '',
            currencyRate: form.currencyRate ?? '',
            disbursementStartDate: disbursementStartDateStr,
            disbursementEndDate: disbursementEndDateStr,
            directResult: form.directResult ?? '',
            finalResult: form.finalResult ?? '',
            loanType: form.loanType?.label ?? '',
            loanDirection: form.loanDirection?.label ?? '',
            loanPurpose: form.loanPurpose?.label ?? '',
            project: form.project?.label ?? '',
            govProgram: form.govProgram?.label ?? '',
            agreementYears: form.agreementYears ?? '',
            benefitMonths: form.benefitMonths ?? '',
            returnDate: returnDateStr,
            rate: form.rate ?? '',
            penalty: form.penalty ?? '',
            status: form.status?.label ?? '',
            isActual: form.isActual,
            noteRu: form.noteRu ?? '',
        }

        return card
    }

    async fetchFiles(agreementId: number): Promise<AgreementFile[]> {
        const response = await fetch(`api/budget-loan/files/agreement/${agreementId}`)
        if (!response.ok) {
            const errorData = await response.json().catch(() => null)
            const errorText = await response.text().catch(() => 'No text')
            console.error(`Error ${response.status}:`, errorData || errorText)
            this.makeToast('Не удалось загузить файлы', 'Ошибка', 'danger')
        }

        const data = await response.json()

        const files: AgreementFile[] = data.map((it: any) => {
            const mapped: AgreementFile = {
                id: it.id,
                fileName: it.fileName,
                description: it.description,
                agreementId: it.agreementId,
                multipartFile: null,
            }
            return mapped
        })

        return files
    }

    public getEmptyText(key: string): string {
        switch (key) {
            case 'creditor': {
                if (!this.form.budgetLevel || !this.form.signDate) {
                    return 'Необходимо указать источник финансирования и дату подписания'
                }
                return 'По выбранному источнику финансирования и дате подписания отсутсвуют данные'
            }
            case 'administrator': {
                if (!this.form.budgetLevel || !this.form.signDate) {
                    return 'Необходимо указать источник финансирования и дату подписания'
                }
                return 'По выбранному источнику финансирования и дате подписания отсутсвуют данные'
            }
            case 'contractor': {
                if (this.form.contractorType === 'GU') {
                    if (!this.form.budgetLevel || !this.form.signDate) {
                        return 'Необходимо указать источник финансирования и дату подписания'
                    }
                    return 'По выбранному источнику финансирования и дате подписания отсутсвуют данные'
                }
                return 'Отсутствуют данные'
            }
            case 'prg': {
                if (!this.form.administrator) {
                    return 'Необходимо указать администратора'
                }
                return 'По выбранному администратору отсутсвуют данные'
            }
            case 'ppr': {
                if (!this.form.administrator || !this.form.prg) {
                    return 'Необходимо указать администратора и код программы'
                }
                return 'По выбранному администратору и коду программы отсутсвуют данные'
            }
            case 'loanPurpose': {
                if (!this.form.signDate) {
                    return 'Необходимо указать дату подписания'
                }
                return 'По выбранной дате подписания отсутсвуют данные'
            }
            case 'govProgram': {
                if (!this.form.signDate) {
                    return 'Необходимо указать дату подписания'
                }
                return 'По выбранной дате подписания отсутсвуют данные'
            }
            default: return 'Отсутствуют данные'
        }
    }

    // #region OnInputs
    public onAgreementYearsInput(value: string) {
        if (!this.form.signDate) {
            return
        }

        const newReturnDate = moment(this.form.signDate).add(value, 'years').toDate()
        this.form.returnDate = newReturnDate
    }

    public formatAmount(value: string) {
        return this.formatNumberWithSpaces(value)
    }

    public async onBudgetLevelInput(selectedOption: Option<number> | null) {
        const budgetLevel = selectedOption?.value ?? null
        await this.resetCreditor(budgetLevel, this.form.signDate)
        await this.resetAdministrator(budgetLevel, this.form.signDate)
        await this.resetContractor(this.form.contractorType, budgetLevel, this.form.signDate)
    }

    public async onSignDateInput(value: Date | null) {
        const budgetLevel = this.form.budgetLevel?.value ?? null

        await this.resetCreditor(budgetLevel, value)
        await this.resetAdministrator(budgetLevel, value)
        await this.resetContractor(this.form.contractorType, budgetLevel, value)

        const modesToNotUpdatePurpose: FormMode[] = ['add-additional', 'add-lower-level']
        if (!modesToNotUpdatePurpose.includes(this.currentMode)) {
            await this.resetloanPurpose(value)
            await this.resetGovProgram(value)
        }
    }

    public async onContractorTypeInput(value: ContractorType) {
        const budgetLevel = this.form.budgetLevel?.value ?? null

        await this.resetContractor(value, budgetLevel, this.form.signDate)
    }

    public async onAdministratorInput(administratorOption: Option<string> | null) {
        const administratorCode: string | null = administratorOption?.value ?? null

        await this.resetPrg(administratorCode)
        await this.resetPpr(administratorCode, null)
    }

    public async onPrgInput(prgOption: Option<string> | null) {
        const administratorCode: string | null = this.form.administrator?.value ?? null
        const prgCode: string | null = prgOption?.value ?? null

        await this.resetPpr(administratorCode, prgCode)
    }
    // #endregion

    private checkUserModuleAccessAndSetAccessLevel() {
        for (const userModuleData of store.state.user.userModules) {
            if (userModuleData.modules === budgetLoanModuleCode) {
                // @ts-ignore
                this.userAccessLevel = userModuleData.access_level
                return true
            }
        }
        return false
    }

    setServerRegion() {
        if (store.state._instanceCode) {
            this.serverKatoRegion = store.state._instanceCode
        } else {
            this.serverKatoRegion = '55' // В тестовой среде присвоить регион павлодара
        }
    }

    async setUserRegions() {
        const response = await fetch(`/api-py/user-region/${this.userId}`)
        if (!response.ok) {
            this.makeToast('Не удалось загузить регионы пользователя', 'Ошибка', 'danger')
            return
        }
        const userRegionObjects = await response.json()
        const userRegions = userRegionObjects.map((it: any) => it.region)
        this.userRegions = userRegions
    }

    async setUserBudgetLevels() {
        const response = await fetch(`/api-py/get-user-budget-level-only/${this.userId}`)
        const data = await response.json()
        const levels = data.map((it: any) => Number(it))
        this.userBudgetLevels = levels
    }

    async loadAgreementByIdAndSetMode(agreementId: number | null, mode: FormMode) {
        this.loading = true
        this.progress = 20

        this.form = initialForm

        if (agreementId) {
            await this.setAgreementForms(agreementId)
        } else {
            this.currentMode = 'add'
            await this.setOptions([])
            this.options = this.agreementOptions[-1]
        }

        this.progress = 50

        switch (mode) {
            case 'view': {
                this.currentMode = 'view'
                break
            }
            case 'add-additional': {
                const actual = this.allAgreementForms.find(it => it.isActual)!
                this.form = cloneDeep(actual)
                this.onOpenAdditionalAgreement()
                break
            }
            case 'add-lower-level': {
                const actual = this.allAgreementForms.find(it => it.isActual)!
                this.form = cloneDeep(actual)
                this.onOpenLowerLevelAgreement()
                break
            }
            case 'edit': {
                this.onOpenEditMode()
                break
            }
            default:
        }

        this.progress = 100
        this.loading = false
    }

    private async setOptions(agreements: Agreement[]) {
        const projectOptions: Option<string>[] = await this.fetchProjects()

        const newFormOptions = {
            budgetLevels: budgetLevelOptions,
            creditors: [],
            currencies: currencyOptions,
            loanTypes: loanTypeOptions,
            loanDirections: loanDirectionOptions,
            loanPurposes: [],
            administrators: [],
            contractorTypes: contractorTypeOptions,
            contractors: [],
            prgs: [],
            pprs: [],
            projects: projectOptions,
            govPrograms: [],
            statuses: statusOptions,
        }

        for (const agreement of agreements) {
            const contractorType: ContractorType = agreement.contractor.length === 7 ? 'GU' : 'OTHER'
            const signDate: Date = new Date(agreement.signDate)

            const loanPurposeOptions: Option<string>[] = await this.fetchLoanPurposeOptions(agreement.signDate)
            const creditorOptions: Option<string>[] = await this.fetchCreditors(agreement.budgetLevel, signDate)
            const administratorOptions: Option<string>[] = await this.fetchAdministrators(agreement.budgetLevel, signDate)
            const contractorOptions: Option<string>[] = await this.fetchContractors(contractorType, agreement.budgetLevel, signDate)
            const prgOptions: Option<string>[] = await this.fetchPrgs(agreement.administrator)
            const pprOptions: Option<string>[] = await this.fetchPprs(agreement.administrator, agreement.prg)
            const govProgramOptions: Option<string>[] = await this.fetchGovPrograms(signDate)


            const options: FormOptions = {
                budgetLevels: budgetLevelOptions,
                creditors: creditorOptions,
                currencies: currencyOptions,
                loanTypes: loanTypeOptions,
                loanDirections: loanDirectionOptions,
                loanPurposes: loanPurposeOptions,
                administrators: administratorOptions,
                contractorTypes: contractorTypeOptions,
                contractors: contractorOptions,
                prgs: prgOptions,
                pprs: pprOptions,
                projects: projectOptions,
                govPrograms: govProgramOptions,
                statuses: statusOptions,
            }

            const agreementId = agreement.id ?? -1
            this.agreementOptions[agreementId] = cloneDeep(options)
        }
        this.agreementOptions[-1] = cloneDeep(newFormOptions)
    }

    private async fetchLoanPurposeOptions(signDate: string | null): Promise<Option<string>[]> {
        if (!signDate) {
            return []
        }

        const response = await fetch(`/api/dict/bc_goal/active-by-date?date=${signDate}`)
        if (!response.ok) {
            this.makeToast('TODO: msg', 'Ошибка', 'danger')
            return []
        }

        const responseData = await response.json()

        const loadPurposeOptions: Option<string>[] = responseData.map((it: any) => {
            return {
                value: it.code,
                label: it.nameRu
            }
        })

        return loadPurposeOptions
    }

    private async resetCreditor(budgetLevel: number | null, signDate: Date | null) {
        this.loadings.creditor = true
        this.form.creditor = null
        this.setCreditorOptions(budgetLevel, signDate)
        this.loadings.creditor = false
    }

    private async setCreditorOptions(budgetLevel: number | null, signDate: Date | null) {
        this.options.creditors = []
        this.options.creditors = await this.fetchCreditors(budgetLevel, signDate)
    }

    private async fetchCreditors(budgetLevel: number | null, signDate: Date | null): Promise<Option<string>[]> {
        if (budgetLevel == null || signDate == null) {
            return []
        }

        const strSignDate = moment(signDate).format('YYYY-MM-DD')
        const isRepublicanLevel = budgetLevel === 1

        let url = ''
        if (isRepublicanLevel) {
            url = '/api/budget-loan/options/creditors/republican'
        } else {
            if (signDate) {
                url = `/api/budget-loan/options/creditors/oblast?sign-date=${strSignDate}`
            } else {
                return []
            }
        }

        const response = await fetch(url)
        const responseData = await response.json()

        const creditorsOptions: Option<string>[] = responseData.map((it: any) => {
            let value = ''
            let label = ''
            if (isRepublicanLevel) {
                value = String(it.abp)
                label = `${it.abp} - ${it.nameRu}`
            } else {
                value = it.code
                label = `${it.code} - ${it.nameRu}`
            }

            return {
                label: label,
                value: value
            }
        })

        return creditorsOptions
    }

    private async resetAdministrator(budgetLevel: number | null, signDate: Date | null) {
        this.loadings.creditor = true
        this.form.administrator = null
        this.setAdministratorOptions(budgetLevel, signDate)
        this.loadings.creditor = false
    }

    private async setAdministratorOptions(budgetLevel: number | null, signDate: Date | null) {
        this.options.administrators = []
        this.options.administrators = await this.fetchAdministrators(budgetLevel, signDate)
    }

    private async fetchAdministrators(budgetLevel: number | null, signDate: Date | null): Promise<Option<string>[]> {
        if (budgetLevel == null || signDate == null) {
            return []
        }

        const strSignDate = moment(signDate).format('YYYY-MM-DD')
        const isRepublicanLevel = budgetLevel === 1
        let level: 'republican' | 'oblast' = 'oblast'
        if (isRepublicanLevel) {
            level = 'republican'
        }
        const params = {
            'sign-date': strSignDate,
            'budget-level': String(budgetLevel)
        }

        const query = new URLSearchParams(params).toString()
        const response = await fetch(`/api/budget-loan/options/administrators/${level}?${query}`)
        const responseData = await response.json()

        const administatorOptions: Option<string>[] = responseData.map((it: any) => {
            const label = `${it.code} - ${it.nameRu}`
            return {
                label: label,
                value: it.code
            }
        })

        return administatorOptions
    }

    private async resetContractor(contractorType: ContractorType, budgetLevel: number | null, signDate: Date | null) {
        this.loadings.contractor = true
        this.form.contractor = null
        this.setContractorOptions(contractorType, budgetLevel, signDate)
        this.loadings.contractor = false
    }

    private async setContractorOptions(contractorType: ContractorType, budgetLevel: number | null, signDate: Date | null) {
        this.options.contractors = []
        this.options.contractors = await this.fetchContractors(contractorType, budgetLevel, signDate)
    }

    private async fetchContractors(contractorType: ContractorType, budgetLevel: number | null, signDate: Date | null): Promise<Option<string>[]> {
        let url = ''
        if (contractorType === 'GU') {
            if (budgetLevel == null || signDate == null) {
                return []
            }

            const strSignDate = moment(signDate).format('YYYY-MM-DD')
            const params = {
                'sign-date': strSignDate,
                'budget-level': String(budgetLevel)
            }
            const query = new URLSearchParams(params).toString()
            url = `/api/budget-loan/options/contractors/gu?${query}`
        } else if (contractorType === 'OTHER') {
            url = 'api/dict/bc_contractor/server-region/by-bin-or-name'
        } else {
            return []
        }

        const response = await fetch(url)
        const responseData = await response.json()

        const contractorOptions: Option<string>[] = responseData.map((it: any) => {
            let value = ''
            if (contractorType === 'GU') {
                value = it.code
            } else if (contractorType === 'OTHER') {
                value = it.bin
            }
            const label = `${value} - ${it.nameRu}`

            return {
                label: label,
                value: value
            }
        })

        return contractorOptions
    }

    private async resetPrg(administratorCode: string | null) {
        this.loadings.prg = true
        this.form.prg = null
        this.setPrgOptions(administratorCode)
        this.loadings.prg = false
    }

    private async setPrgOptions(administratorCode: string | null) {
        this.options.prgs = []
        this.options.prgs = await this.fetchPrgs(administratorCode)
    }

    private async fetchPrgs(administratorCode: string | null): Promise<Option<string>[]> {
        if (!administratorCode) {
            return []
        }

        const abp = administratorCode.substring(0, 3)
        const params = {
            'abp': abp
        }
        const query = new URLSearchParams(params).toString()
        const response = await fetch(`/api/budget-loan/options/prg?${query}`)
        const responseData = await response.json()

        const prgOptions: Option<string>[] = responseData.map((it: any) => {
            const paddedPrg: string = String(it.prg).padStart(3, '0')
            const label = `${paddedPrg} - ${it.nameRu}`
            return {
                label: label,
                value: String(it.prg)
            }
        })

        return prgOptions
    }

    private async resetPpr(administratorCode: string | null, prg: string | null) {
        this.loadings.ppr = true
        this.form.ppr = null
        this.setPprOptions(administratorCode, prg)
        this.loadings.ppr = false
    }

    private async setPprOptions(administratorCode: string | null, prg: string | null) {
        this.options.pprs = []
        this.options.pprs = await this.fetchPprs(administratorCode, prg)
    }

    private async fetchPprs(administratorCode: string | null, prg: string | null): Promise<Option<string>[]> {
        if (!administratorCode || !prg) {
            return []
        }

        const abp = administratorCode.substring(0, 3)
        const params = {
            'abp': abp,
            'prg': prg
        }
        const query = new URLSearchParams(params).toString()
        const response = await fetch(`/api/budget-loan/options/ppr?${query}`)
        const responseData = await response.json()

        const pprOptions: Option<string>[] = responseData.map((it: any) => {
            const paddedPpr: string = String(it.ppr).padStart(3, '0')
            const label = `${paddedPpr} - ${it.nameRu}`
            return {
                label: label,
                value: String(it.ppr)
            }
        })

        return pprOptions
    }

    private async resetloanPurpose(signDate: Date | null) {
        this.loadings.loanPurpose = true
        this.form.loanPurpose = null
        this.setLoanPurposeOptions(signDate)
        this.loadings.loanPurpose = false
    }

    private async setLoanPurposeOptions(signDate: Date | null) {
        this.options.loanPurposes = []
        this.options.loanPurposes = await this.fetchLoanPurposes(signDate)
    }

    private async fetchLoanPurposes(signDate: Date | null): Promise<Option<string>[]> {
        if (!signDate) {
            return []
        }

        const strSignDate = moment(signDate).format('YYYY-MM-DD')
        const params = { 'date': strSignDate }
        const query = new URLSearchParams(params).toString()
        const response = await fetch(`/api/dict/bc_goal/active-by-date?${query}`)
        const responseData = await response.json()

        const options: Option<string>[] = responseData.map((it: any) => {
            return {
                label: it.nameRu,
                value: it.code
            }
        })

        return options
    }

    private async setProjectOptions() {
        this.options.projects = []
        this.options.projects = await this.fetchProjects()
    }

    private async fetchProjects(): Promise<Option<string>[]> {
        const response = await fetch('/api/dict/bc_project')
        const responseData = await response.json()

        const options: Option<string>[] = responseData.map((it: any) => {
            return {
                label: it.nameRu,
                value: it.code
            }
        })

        return options
    }

    private async resetGovProgram(signDate: Date | null) {
        this.loadings.govProgram = true
        this.form.govProgram = null
        this.setGovProgramOptions(signDate)
        this.loadings.govProgram = false
    }

    private async setGovProgramOptions(signDate: Date | null) {
        this.options.govPrograms = []
        this.options.govPrograms = await this.fetchGovPrograms(signDate)
    }

    private async fetchGovPrograms(signDate: Date | null): Promise<Option<string>[]> {
        if (!signDate) {
            return []
        }

        const strSignDate = moment(signDate).format('YYYY-MM-DD')
        const params = { 'sign-date': strSignDate }
        const query = new URLSearchParams(params).toString()
        const response = await fetch(`/api/budget-loan/options/programs?${query}`)
        const responseData = await response.json()

        const options: Option<string>[] = responseData.map((it: any) => {
            return {
                label: it.nameRu,
                value: it.code
            }
        })

        return options
    }

    private onOpenEditMode() {
        this.idsOfFilesToDelete = []
        if (this.currentMode === 'edit' && this.tempForm && this.tempOptions) {
            this.currentMode = 'view'
            this.form = this.tempForm
            this.options = this.tempOptions
        } else {
            this.currentMode = 'edit'
            this.tempForm = cloneDeep(this.form)
            this.tempOptions = cloneDeep(this.options)
        }
    }

    private async onOpenLowerLevelAgreement() {
        if (this.currentMode === 'add-lower-level' && this.tempForm && this.tempOptions) {
            this.currentMode = 'view'
            this.form = this.tempForm
            this.options = this.tempOptions
            return
        }

        this.currentMode = 'add-lower-level'
        this.tempForm = cloneDeep(this.form)
        this.tempOptions = cloneDeep(this.options)

        const mainAgreementForm: AgreementForm = this.allAgreementForms.find(it => it.type === 0)!
        this.form.id = null
        this.form.mainAgreementId = mainAgreementForm.id
        this.form.mainAgreementNumber = mainAgreementForm.agreementNumber
        this.form.disbursementStartDate = mainAgreementForm.disbursementStartDate
        this.form.disbursementEndDate = mainAgreementForm.disbursementEndDate
        this.form.type = 0
        this.form.agreementNumber = ''
        this.form.signDate = null
        this.form.noteRu = null
        this.form.noteKz = null
        this.form.currencyRate = null
        this.form.files = []
        this.form.isActual = true

        const oblastBudgetLevelOption = cloneDeep(this.options.budgetLevels.find(it => it.value === 2)!)
        this.form.budgetLevel = oblastBudgetLevelOption
        await this.onBudgetLevelInput(oblastBudgetLevelOption)
    }

    public onOpenAdditionalAgreement() {
        if (this.currentMode === 'add-additional' && this.tempForm && this.tempOptions) {
            this.currentMode = 'view'
            this.form = this.tempForm
            this.options = this.tempOptions
            return
        }

        this.currentMode = 'add-additional'
        this.tempForm = cloneDeep(this.form)
        this.tempOptions = cloneDeep(this.options)

        this.form.id = null
        this.form.type = 1
        const mainAgreementForm = this.allAgreementForms.find(it => it.type === 0)!
        this.form.mainAgreementNumber = mainAgreementForm.agreementNumber
        this.form.mainAgreementId = mainAgreementForm.id
        this.form.agreementNumber = `${mainAgreementForm.agreementNumber}/${this.allAgreementForms.length}`
        this.form.disbursementStartDate = cloneDeep(mainAgreementForm.disbursementStartDate)
        this.form.disbursementEndDate = cloneDeep(mainAgreementForm.disbursementEndDate)
        this.form.noteRu = null
        this.form.noteKz = null
        this.form.currencyRate = null
        this.form.files = []
        this.form.isActual = true
    }

    async setAgreementForms(agreementId: number) {
        // Agreements
        const agreements: Agreement[] = await this.getAgreements(agreementId)
        this.allAgreements = agreements

        // Options
        await this.setOptions(this.allAgreements)
        this.options = cloneDeep(this.agreementOptions[agreementId])

        // AgreementForms
        const mainAgreement = agreements.find(it => it.type === 0)!
        const mainAgreementNumber = mainAgreement.agreementNumber

        const agreementForms: AgreementForm[] = []
        for (let i = 0; i < agreements.length; i++) {
            const agreement = agreements[i]
            const currentOptions = this.agreementOptions[agreement.id ?? -1]
            const form = await this.agreementToAgreementForm(agreement, currentOptions, mainAgreementNumber, i)
            form.files = await this.fetchFiles(form.id!)
            agreementForms.push(form)
        }
        this.allAgreementForms = agreementForms

        this.progress = 50


        const displayAgreement = agreementForms.find(it => it.id === agreementId)
        if (displayAgreement == null) {
            throw new Error('') // TODO: error message
        }

        this.form = cloneDeep(displayAgreement)

        const tempMainForm = agreementForms.find(it => it.type === 0)
        if (tempMainForm == null) {
            throw new Error('') // TODO: error message
        }
        this.mainAgreementForm = cloneDeep(tempMainForm)

        const tempActual = agreementForms.find(it => it.isActual)
        if (tempActual == null) {
            throw new Error('') // TODO: error message
        }
        this.actualAgreementForm = cloneDeep(tempActual)

        this.currentAgreementId = agreementId
    }

    async getAgreements(id: number): Promise<Agreement[]> {
        const response = await fetch(`/api/budget-loan/with-additionals/${id}`)
        if (!response.ok) {
            this.makeToast('Не удалось загрузить договора', 'Сообщение', 'danger')
            return []
        }
        const agreements: Agreement[] = await response.json()
        return agreements
    }

    // agreementsToAgreementForms(agreemnts) {
    //     const transformed = agreemnts.map(item => this.transformSingleReceivedAgreement(item))
    //     const main = transformed.find(item => item.type === 0)
    //     // Проставление номера основого договара на допики для отображения
    //     transformed.map(item => {
    //         if (item.numberContractMain) {
    //             item.numberContractMainId = item.numberContractMain
    //             item.numberContractMain = main.numberContract
    //         }
    //     })
    //     return transformed
    // },

    private async agreementToAgreementForm(
        source: Agreement,
        options: FormOptions,
        mainAgreeementNumber: string,
        index: number
    ): Promise<AgreementForm> {
        let label = source.agreementNumber
        if (source.type === 0) {
            label += ` (Основной) от ${source.signDate}`
        } else {
            label += ` (Дополнение) от ${source.signDate}`
        }
        if (source.flagActual === 1) {
            label += ' (Актуальный)'
        }
        const budgetLevelOption: Option<number> | null = options.budgetLevels.find(it => it.value === source.budgetLevel) ?? null
        const contractorType: ContractorType = source.contractor.length === 7 ? 'GU' : 'OTHER'

        const loanTypeOption: Option<string> | null = options.loanTypes.find(it => it.value === source.loanType) ?? null
        const loanDirectionOption: Option<string> | null = options.loanDirections.find(it => it.value === String(source.loanDirection)) ?? null
        let loanPurposeOption: Option<string> | null = options.loanPurposes.find(it => it.value === source.loanPurpose) ?? null
        const projectOption: Option<string> | null = options.projects.find(it => it.value === source.project) ?? null
        let govProgramOption: Option<string> | null = options.govPrograms.find(it => it.value === source.govProgram) ?? null
        let creditorOption: Option<string> | null = options.creditors.find(it => it.value === source.creditor) ?? null
        let administratorOption: Option<string> | null = options.administrators.find(it => it.value === source.administrator) ?? null
        let contractorOption: Option<string> | null = options.contractors.find(it => it.value === source.contractor) ?? null
        const prgOption: Option<string> | null = options.prgs.find(it => it.value === source.prg) ?? null
        const pprOption: Option<string> | null = options.pprs.find(it => it.value === source.ppr) ?? null
        const currencyOption: Option<string> | null = options.currencies.find(it => it.value === source.currency) ?? null
        const statusOption: Option<number> | null = options.statuses.find(it => it.value === source.statusId) ?? null

        // Запрос параметров где есть значение но нету в options
        const missingOptions: Record<string, string> = {}
        if (source.creditor && creditorOption == null) {
            missingOptions['creditor'] = source.creditor
        }
        if (source.administrator && administratorOption == null) {
            missingOptions['administrator'] = source.administrator
        }
        if (source.contractor && contractorOption == null) {
            missingOptions['contractor'] = source.contractor
        }
        if (source.loanPurpose && loanPurposeOption == null) {
            missingOptions['loan-purpose'] = source.loanPurpose
        }
        if (source.govProgram && govProgramOption == null) {
            missingOptions['gov-program'] = source.govProgram
        }
        let values: Record<string, any> = {}
        if (Object.keys(missingOptions).length > 0) {
            const query = new URLSearchParams(missingOptions).toString()
            const response = await fetch(`/api/budget-loan/options/missing?${query}`)
            const data = await response.json()
            values = data
        }
        // SIDE-EFFECTS
        if (values.creditor) {
            const nameRu = `${values.creditor.code} - ${values.creditor.nameRu}`
            creditorOption = { value: values.creditor.code, label: nameRu }
            options.creditors.push(creditorOption)
        }
        if (values.administrator) {
            const nameRu = `${values.administrator.code} - ${values.administrator.nameRu}`
            administratorOption = { value: values.administrator.code, label: nameRu }
            options.administrators.push(administratorOption)
        }
        if (values.contractor) {
            contractorOption = { value: values.contractor.value, label: values.contractor.label }
            options.contractors.push(contractorOption)
        }
        if (values.contractor) {
            contractorOption = { value: values.contractor.value, label: values.contractor.label }
            options.contractors.push(contractorOption)
        }
        if (values.loanPurpose) {
            loanPurposeOption = { value: values.loanPurpose.code, label: values.loanPurpose.nameRu }
            options.loanPurposes.push(loanPurposeOption)
        }
        if (values.govProgram) {
            govProgramOption = { value: values.govProgram.code, label: values.govProgram.nameRu }
            options.govPrograms.push(govProgramOption)
        }

        const amount: string = this.formatNumberWithSpaces(String(source.amount))

        let currencyRate: string | null = null
        if (source.currencyRate != null) {
            currencyRate = source.currencyRate.toString()
        }

        const benefitMonths: string = source.benefitMonths.toString()
        const rate: string = source.rate.toString()
        const penalty: string = source.penalty.toString()

        let tempMainAgreementNumber = ''
        if (source.type === 1) {
            tempMainAgreementNumber = mainAgreeementNumber
        }

        const target: AgreementForm = {
            id: source.id,
            budgetLevel: budgetLevelOption,
            agreementNumber: source.agreementNumber,
            signDate: new Date(source.signDate),
            returnDate: new Date(source.returnDate),
            agreementYears: String(source.agreementYears),
            mainAgreementNumber: tempMainAgreementNumber,
            mainAgreementId: source.mainAgreementId,
            loanType: loanTypeOption,
            loanDirection: loanDirectionOption,
            loanPurpose: loanPurposeOption,
            project: projectOption,
            govProgram: govProgramOption,
            creditor: creditorOption,
            administrator: administratorOption,
            contractorType: contractorType,
            contractor: contractorOption,
            prg: prgOption,
            ppr: pprOption,
            amount: amount,
            currency: currencyOption,
            currencyRate: currencyRate,
            benefitMonths: benefitMonths,
            disbursementStartDate: new Date(source.disbursementStartDate),
            disbursementEndDate: new Date(source.disbursementEndDate),
            directResult: source.directResult,
            finalResult: source.finalResult,
            rate: rate,
            penalty: penalty,
            status: statusOption,
            isActual: source.flagActual === 1,
            type: source.type,
            noteRu: source.noteRu,
            noteKz: source.noteKz,
            files: [],

            index: index,
            label: label,
            leftAmount: source.leftAmount,
            regionCode: source.regionCode,
            frequency: source.frequency,
            frequencyRate: source.frequencyRate,
            frequencyIncome: source.frequencyIncome,
            initialInterestRepaymentDate: source.initialInterestRepaymentDate,
            followingInterestRepaymentMonth: source.followingInterestRepaymentMonth,
            followingInterestRepaymentDay: source.followingInterestRepaymentDay,
            flagActual: source.flagActual,
            flagError: source.flagError,
            userName: source.userName,
            updateDate: source.updateDate
        }

        return target
    }

    private makeToast(message: string, title: string, variant: 'success' | 'danger' | 'info') {
        this.$bvToast.toast(message, {
            title: title,
            variant: variant,
            solid: true
        })
    }

    public isDisabled(key: keyof AgreementForm) {
        if (key === 'isActual' || key === 'mainAgreementNumber') {
            return true
        }
        else if (key === 'currencyRate' && this.form.currency?.value === '398') {
            return true
        }
        else if (key === 'creditor' && this.loadings.creditor) {
            return true
        }
        else if (key === 'administrator' && this.loadings.administrator) {
            return true
        }
        else if (key === 'contractor' && this.loadings.contractor) {
            return true
        }
        else if (key === 'prg' && this.loadings.prg) {
            return true
        }
        else if (key === 'ppr' && this.loadings.ppr) {
            return true
        }
        else if (key === 'loanPurpose' && this.loadings.loanPurpose) {
            return true
        }
        else if (key === 'project' && this.loadings.project) {
            return true
        }
        else if (key === 'govProgram' && this.loadings.govProgram) {
            return true
        }
        else if (this.currentMode === 'add-additional') {
            if (notEditableAdditionalAgreementFields.includes(key)) {
                return true
            }
        }
        else if (this.currentMode === 'add-lower-level') {
            if (notEditableLowerLevelAgreementFields.includes(key)) {
                return true
            }
        }
        else if (this.currentMode === 'edit') {
            if (!editableFields.includes(key)) {
                return true
            }
        }
        else if (this.currentMode === 'view') {
            return true
        }
        return false
    }

    public onEditModalText(key: keyof AgreementForm) {
        let label = ''
        if (key === 'directResult') {
            label = 'Прямой результат'
        } else if (key === 'finalResult') {
            label = 'Конечный результат'
        }
        this.modalEditingFieldName = label

        if (typeof this.form[key] === 'string') {
            this.tempModalText = String(this.form[key])
        } else {
            this.tempModalText = ''
        }

        this.selectedTextField = key
        this.inputTextModalVisibility = true
    }


    public goBack() {
        if (this.tableQuery) {
            this.$router.push({
                name: 'budget-loan-table',
                params: { tableQuery: this.tableQuery }
            })
        } else {
            this.$router.push('/budget-loan-table')
        }
    }

    public checkForm() {
        if ((['add', 'add-additional', 'add-lower-level', 'edit'] as FormMode[]).includes(this.currentMode)) {
            this.saveOrUpdate()
        }
        // TODO: implement validator
        // this.$v.NewItem.$touch()
        // if (!this.$v.NewItem.$error) {
        //     this.saveOrUpdate()
        // }
    }


    private formatNumberWithSpaces(value: number | string): string {
        if (!value) {
            return String(value)
        }

        let formatted: string = String(value)

        const removedSpaceString = formatted.replace(/\s/g, "")
        formatted = removedSpaceString.replace(/\B(?=(\d{3})+(?!\d))/g, " ")

        return formatted
    }

    private formToAgreement(source: AgreementForm): Agreement {
        let isValid = true
        const errorMessages: string[] = []
        if (source.budgetLevel == null) {
            isValid = false
            errorMessages.push('Не указан уровень бюджета')
        }
        if (source.signDate == null) {
            isValid = false
            errorMessages.push('Не указана дата подписания')
        }
        if (source.returnDate == null) {
            isValid = false
            errorMessages.push('Не указана дата возврата')
        }
        if (source.disbursementStartDate == null) {
            isValid = false
            errorMessages.push('Не указано начало периода освоения')
        }
        if (source.disbursementEndDate == null) {
            isValid = false
            errorMessages.push('Не указан конец периода освоения')
        }
        if (source.loanType == null) {
            isValid = false
            errorMessages.push('Не указан вид займа')
        }
        if (source.loanDirection == null) {
            isValid = false
            errorMessages.push('Не указано направление кредита')
        }
        if (source.loanPurpose == null) {
            isValid = false
            errorMessages.push('Не указана цель бюджетного кредитования')
        }
        if (source.project == null) {
            isValid = false
            errorMessages.push('Не указан проект')
        }
        if (source.creditor == null) {
            isValid = false
            errorMessages.push('Не указан кредитор')
        }
        if (source.administrator == null) {
            isValid = false
            errorMessages.push('Не указан администратор')
        }
        if (source.contractor == null) {
            isValid = false
            errorMessages.push('Не указан заемщик')
        }
        if (source.currency == null) {
            isValid = false
            errorMessages.push('Не указана валюта')
        }
        if (source.status == null) {
            isValid = false
            errorMessages.push('Не указан статус')
        }

        const rate: number = Number(source.rate)
        if (rate.isNaN) {
            isValid = false
            errorMessages.push('Не указана ставка вознаграждения')
        }

        const benefitMonths: number = Number(source.benefitMonths)
        if (benefitMonths.isNaN) {
            isValid = false
            errorMessages.push('Не указан льготный период')
        }

        const penalty: number = Number(source.penalty)
        if (penalty.isNaN) {
            isValid = false
            errorMessages.push('Не указана пеня')
        }

        if (!isValid) {
            // @ts-ignore
            const errorOptions: ErrorOptions = {
                cause: errorMessages
            }
            // @ts-ignore
            throw new Error('', errorOptions)
        }

        const strSignDate = moment(source.signDate).format('YYYY-MM-DD')
        const strReturnDate = moment(source.returnDate).format('YYYY-MM-DD')
        const budgetLevel: number = source.budgetLevel!.value
        const tempAgreementYears = Number(source.agreementYears ?? 0)
        if (tempAgreementYears.isNaN) {
            throw new Error('String to number convert error (agreementYears)')
        }
        const agreementYears = tempAgreementYears
        const loanType: string = source.loanType!.value
        const loanDirection: number = Number(source.loanDirection!.value)
        const loanPurpose: string = source.loanPurpose!.value
        const project: string = source.project!.value
        const creditor: string = source.creditor!.value
        const administrator: string = source.administrator!.value
        const contractor: string = source.contractor!.value
        const currency: string = source.currency!.value

        const tempAmount = parseSpacedDecimal(source.amount ?? 0)
        if (tempAmount.isNaN) {
            throw new Error('String to number convert error (amount)')
        }
        const amount = tempAmount

        let currencyRate: number | null = null
        if (source.currencyRate) {
            const tempCurrencyRate = Number(source.currencyRate)
            if (tempCurrencyRate.isNaN) {
                throw new Error('String to number convert error (currencyRate)')
            }
            currencyRate = tempCurrencyRate
        }

        const strDisbursementStartDate = moment(source.disbursementStartDate).format('YYYY-MM-DD')
        const strDisbursementEndDate = moment(source.disbursementEndDate).format('YYYY-MM-DD')

        const prg: string | null = source.prg?.value ?? null
        const ppr: string | null = source.ppr?.value ?? null
        const statusId: number = source.status!.value

        const flagActual: 0 | 1 = source.isActual ? 1 : 0

        // TODO: validate agreement number
        const target: Agreement = {
            id: source.id,
            type: source.type,
            budgetLevel: budgetLevel,
            regionCode: source.regionCode ?? null,
            agreementNumber: source.agreementNumber,
            mainAgreementId: source.mainAgreementId,
            signDate: strSignDate,
            returnDate: strReturnDate,
            agreementYears: agreementYears,
            noteRu: source.noteRu,
            noteKz: source.noteKz,
            directResult: source.directResult,
            finalResult: source.finalResult,
            loanType: loanType,
            loanDirection: loanDirection,
            loanPurpose: loanPurpose,
            project: project,
            govProgram: source.govProgram?.value ?? null,
            creditor: creditor,
            administrator: administrator,
            contractor: contractor,
            amount: amount,
            leftAmount: source.leftAmount ?? null,
            currency: currency,
            currencyRate: currencyRate,
            rate: rate,
            benefitMonths: benefitMonths,
            disbursementStartDate: strDisbursementStartDate,
            disbursementEndDate: strDisbursementEndDate,
            penalty: penalty,
            prg: prg,
            ppr: ppr,
            file: null,
            statusId: statusId,

            frequency: source.frequency,
            frequencyRate: source.frequencyRate,
            frequencyIncome: source.frequencyIncome,
            initialInterestRepaymentDate: source.initialInterestRepaymentDate,
            followingInterestRepaymentMonth: source.followingInterestRepaymentMonth,
            followingInterestRepaymentDay: source.followingInterestRepaymentDay,
            flagActual: flagActual,
            flagError: source.flagError,
            userName: source.userName,
            updateDate: source.updateDate
        }

        return target
    }

    async saveOrUpdate() {
        this.loading = true

        let method = 'POST'
        let message = 'Элемент сохранен'
        if (this.currentMode === 'edit') {
            method = 'PUT'
            message = 'Элемент редактирован'
        }

        try {
            const agreement: Agreement = this.formToAgreement(this.form)

            const response = await fetch('/api/budget-loan', {
                method: method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(agreement)
            })

            if (!response.ok) {
                let text = 'Извините, произошла ошибка на сервере или некорректно заполнены поля.'
                const errorResponse = await response.json()
                const key = errorResponse.key
                const message = errorResponse?.args[0]?.value[0]
                if (key) {
                    text = key
                }
                if (message) {
                    text = message
                }
                this.makeToast(text, 'Ошибка сохранения', 'danger');
                throw new Error('response was not ok');
            }

            this.makeToast(message, 'Сообщение', 'success')

            let idToLoad: number | null = null
            let idToAttachFiles: number | null = null
            switch (this.currentMode) {
                case 'add':
                case 'add-additional':
                case 'add-lower-level': {
                    const createdAgreement: Agreement = await response.json()
                    idToLoad = createdAgreement.id
                    idToAttachFiles = createdAgreement.id
                    break
                }
                case 'edit': {
                    idToLoad = this.form.id
                    idToAttachFiles = this.form.id
                    const alerts = await response.json()
                    alerts.forEach((alertMessage: string) => {
                        this.makeToast(alertMessage, 'Примечание', 'danger')
                    })
                    break
                }
                default:
            }

            if (idToAttachFiles) {
                await this.applyFileEdits(idToAttachFiles)
            }

            await this.loadAgreementByIdAndSetMode(idToLoad, 'view')
        } catch (error) {
            if (Array.isArray((error as any)?.cause)) {
                const errorMessages: string[] = (error as any)?.cause
                errorMessages.forEach(message => {
                    this.makeToast(message, 'Сообщение', 'danger')
                })
            }
            console.error(error)
        } finally {
            this.loading = false
        }
    }

    openAdditionalsModal(action: 'open' | 'close' | null = null) {
        if (this.currentMode !== 'view') {
            return
        }

        if (action === 'open') {
            this.showModal = true
        } else if (action === 'close') {
            this.showModal = false
        } else {
            this.showModal = !this.showModal
        }
    }

    setChosenItem(value: AgreementForm | null) {
        if (!value || value.id === this.form.id) {
            return
        }

        this.form = cloneDeep(value)
        this.currentAgreementId = value.id
        this.options = cloneDeep(this.agreementOptions[value.id ?? -1])
    }

    public onOkButton() {
        if (typeof this.form[this.selectedTextField] === 'string') {
            // @ts-ignore
            this.form[this.selectedTextField] = this.tempModalText
        }
        this.tempModalText = ''
        this.inputTextModalVisibility = false
    }

    public async addFile(file: File) {
        if (this.form.files.length >= 5) {
            this.makeToast('Превышено максимальное количество загружаемых файлов', 'Сообщение', 'info')
            return
        }

        let randomId = Math.floor(Math.random() * 101)
        while (this.form.files.findIndex(it => it.id === randomId) !== -1) {
            randomId = Math.floor(Math.random() * 101)
        }

        this.form.files.push({
            id: randomId,
            fileName: file.name,
            description: null,
            agreementId: this.form.id,
            multipartFile: file
        })
    }

    async removeFile(id: number) {
        const toDelete = this.form.files.find(it => it.id === id)
        if (!toDelete?.multipartFile) {
            this.idsOfFilesToDelete.push(id)
        }
        this.form.files = this.form.files.filter(it => it.id !== id)
    }

    async applyFileEdits(agreementId: number) {
        // Deletion
        if (this.idsOfFilesToDelete.length > 0) {
            const idsString: string = this.idsOfFilesToDelete.join(',')
            const response = await fetch(`api/budget-loan/files/delete-storage-files?fileIds=${idsString}`, { method: 'DELETE' })
            if (!response.ok) {
                const error = await response.json()
                console.error(error)
                this.makeToast('Не удалось удалить файл(ы)', 'Ошибка', 'danger')
                return
            }
        }

        // Addition
        const filesToSave = this.form.files.filter(it => it.multipartFile)
        const formDataArray: FormData[] = filesToSave.map(fileItem => {
            fileItem.description = (fileItem.description ?? '')

            const formData = new FormData()
            formData.append('fileName', fileItem.fileName)
            formData.append('agreementId', agreementId.toString())
            formData.append('description', fileItem.description)
            formData.append('multipartFile', fileItem.multipartFile!)

            return formData
        })

        // Create an array of Axios promises
        const requests = formDataArray.map(formData => axios.post('api/budget-loan/files/storage-upload', formData))

        // Use axios.all to send multiple requests concurrently
        axios
            .all(requests)
            .then(axios.spread((...responses) => {
                // responses contains the response for each request
                const data = responses.map(response => response.data)
            }))
            .catch(error => {
                this.makeToast('Не удалось сохранить загруженные(-ый) файл(ы)', 'Ошибка', 'danger')
                console.error(error)
            })

        // description edit
        for (const fileItem of this.form.files) {
            if (!fileItem.multipartFile && this.tempForm) {
                const prevDesc = this.tempForm.files.find(tempFile => tempFile.id === fileItem.id)?.description
                if (fileItem.description !== prevDesc) {
                    await fetch('api/budget-loan/files/update-storage-file', {
                        method: 'PUT',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            id: fileItem.id,
                            fileName: fileItem.fileName,
                            description: fileItem.description,
                            agreementId: fileItem.agreementId
                        })
                    })
                }
            }
        }
    }

    public async handleDeleteAgreement() {
        this.$bvModal.msgBoxConfirm(
            'Удалить выбранный договор?',
            {
                title: 'Подтверждение',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Удалить',
                cancelTitle: 'Отмена',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(confirmed => {
                if (confirmed) {
                    this.deleteAgreement()
                }
            })
            .catch(error => {
                this.makeToast('Не удалось удалить договор', 'Ошибка удаления', 'danger')
                console.error(error.toString())
            })
    }

    private async deleteAgreement() {
        this.loading = true
        const currentAgreementId = this.form.id
        if (currentAgreementId == null) {
            return
        }

        const response = await this.deleteAgreementById(currentAgreementId)

        if (response.ok) {
            this.makeToast('Договор удален', 'Сообщение', 'success')
            if (currentAgreementId !== this.mainAgreementForm?.id) {
                this.currentAgreementId = null
                await this.loadAgreementByIdAndSetMode(this.mainAgreementForm!.id, 'view')
            } else {
                setTimeout(() => {
                    this.$router.replace('/budget-loan-table')
                }, 500)
            }
        } else {
            const errorResponse = await response.json()
            const message = errorResponse?.args[0]?.value[0]
            this.makeToast(message, 'Ошибка', 'danger')
        }
        this.loading = false
    }

    private async deleteAgreementById(id: number) {
        const response = await fetch(`/api/budget-loan/${id}`, { method: 'DELETE' })
        return response
    }

    public changeModeFromAddToReadOnly() {
        if (this.currentMode === 'add') {
            this.currentMode = 'view'
        } // TODO: uncomment after changing mode implementation
    }

    public reloadFact() {
        // reload fact
        if (this.actualAgreementForm == null) {
            return
        }

        if (this.actualAgreementForm.index >= 0) {
            this.actualAgreementForm.index = -1
        } else {
            this.actualAgreementForm.index -= 1
        }

        // reload forecast
        this.forecastTabKey = this.forecastTabKey + 1
    }

    reloadForecast() {
        this.forecastTabKey = this.forecastTabKey + 1
    }

    setPlan(planData: any) {
        this.planData = planData
    }

    setFact(factData: any) {
        this.factData = factData
    }
    // #endregion
}
